/* eslint-disable import/no-cycle */
import { USERS_WITH_INPUT_KPI_PERMISSION } from "lib/constants";
import { getAPICall } from "../lib/callApi";

export const fetchCompanyUsers = async (payload) => {
  const data = await getAPICall(USERS_WITH_INPUT_KPI_PERMISSION, true, payload);
  return data;
};
